import { AbstractPmsApiService } from "./abstract.service";
import {Reservation} from "../models";

/**
 * @class EventCalendarPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Reservation>}
 */
export class EventCalendarPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/event-calendar';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {EventAdditionalOption}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new Reservation(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<EventAdditionalOption>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});

        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }

    checkMove(params = {}, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
            .post(url + '/checkAvailability', params, {
                headers: this.authHeaders,
                ignoreLoadingBar: true
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/event-calendar.service.js